/** Explore parent row — matches sidebar primary Lottie size. */
export const EXPLORE_PARENT_ICON_PX = 18;
